import i18n from 'i18n-js';

import { Paths } from '@x-guard/xgac-types/utils';
import en from './locales/en';
import nl from './locales/nl';
import fr from './locales/fr';
import de from './locales/de';

i18n.fallbacks = true;
i18n.translations = {
  en, nl, fr, de,
};

const browserLanguage = navigator.language.split('-')[0];
i18n.locale = ['en', 'nl', 'fr', 'de'].includes(browserLanguage) ? browserLanguage : 'en';

// Get all the translation keys
export type TranslationKey = Paths<typeof en, string | {
  other: string;
  one?: string;
  zero?: string;
}>;

export type TranslationFunc = <T extends TranslationKey>(searchString: T, option?: object) => string;

// global translation
// This can be manually imported in ts files, which provides static typechecking again translation keys
export const t: TranslationFunc = (searchString, options = {}) => {

  return i18n.t(searchString, options);

};
